import React from 'react';
import '../styles/Certifications.css';
import threatdefenceLogo from '../assets/images/threatdefence.png';
import cbaLogo from '../assets/images/Commonwealth-Bank-Symbol.png';
import mastercardLogo from '../assets/images/mastercard.png';
interface CertificationItemProps {
  title: string;
  issuer: string;
  date: string;
  description: string;
  credentialId?: string;
  credentialURL?: string;
  skills?: string[];
  icon?: React.ReactNode;
}

const CertificationItem: React.FC<CertificationItemProps> = ({
  title,
  issuer,
  date,
  description,
  credentialId,
  credentialURL,
  skills,
  icon
}) => {
  return (
    <div className="certification-item">
      <div className={`certification-icon${icon ? ' has-custom-icon' : ''}`}>
        {icon ? icon : <span>🔐</span>}
      </div>
      <div className="certification-content">
        <h3>{title}</h3>
        <div className="certification-meta">
          <span className="issuer">{issuer}</span>
          <span className="date">{date}</span>
        </div>
        <p className="description">{description}</p>

        {credentialId && (
          <div className="credential-id">
            <span className="label">Credential ID:</span>
            {credentialURL ? (
              <a href={credentialURL} target="_blank" rel="noopener noreferrer">{credentialId}</a>
            ) : (
              <span>{credentialId}</span>
            )}
          </div>
        )}

        {skills && skills.length > 0 && (
          <div className="skills">
            {skills.map((skill, index) => (
              <span key={index} className="skill-tag">{skill}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const Certifications: React.FC = () => {
  const certificationData: CertificationItemProps[] = [
    {
      title: "Threat Defence and Incident Response Program",
      issuer: "ThreatDefence",
      date: "May 2024",
      description:
        "Provided hands-on experience in analysing logs and alerts using the ThreatDefence Console, mapping findings to the MITRE ATT&CK Framework, and writing an incident response report for a hypothetical ransomware incident.",
      credentialId: "LinkedIn Post",
      credentialURL: "https://www.linkedin.com/posts/ryankennedysec_just-wrapped-up-a-5-week-cybersecurity-program-activity-7192025176585261059-S9ak?utm_source=share&utm_medium=member_desktop&rcm=ACoAADqBo0gBQl6Ox_UVaGUw9JkABNLqyxpNSpc",
      skills: [
        "Incident Response",
        "Log Analysis",
        "MITRE ATT&CK",
        "Threat Investigation",
        "Open Source Intelligence",
      ],
      icon: <img src={threatdefenceLogo} alt="ThreatDefence Logo" style={{width: 45, height: 45, objectFit: 'contain', borderRadius: 6}} />
    },
    {
      title: "Introduction to Cybersecurity Job Simulation",
      issuer: "Commonwealth Bank (via Forage)",
      date: "Aug 2024",
      description:
        "Completed a simulation covering Splunk dashboard creation, incident response, secure password practices, and basic web application penetration testing.",
      credentialId: "HmrRhsCYrLhexnNFE",
      credentialURL: "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/Commonwealth%20Bank/x52Jy9s26xNbZkTQ7_Commonwealth%20Bank_gX3ne5v6wghAgGeSD_1723791486421_completion_certificate.pdf",
      skills: [
        "Compliance Knowledge",
        "Creative Thinking",
        "Cyber Security",
        "Data Analysis",
        "Data Protection",
        "Data Visualisation",
        "Detection and Response",
        "Incident Triage",
        "Password Security",
        "Penetration Testing",
        "Problem Solving",
        "Splunk Basics"
      ],
      icon: <img src={cbaLogo} alt="Commonwealth Bank Logo" style={{width: 70, height: 70, objectFit: 'contain', borderRadius: 6}} />
    },
    {
      title: "Mastercard Cybersecurity virtual experience program",
      issuer: "Mastercard (via Forage)",
      date: "May 2025",
      description:
        "Completed a job simulation where I served as an analyst on Mastercard’s Security Awareness Team, helping identify and report security threats such as phishing emails and suspicious activity.",
      credentialId: "r5WazHAZ5wLXkm6tF",
      credentialURL: "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/mfxGwGDp6WkQmtmTf/vcKAB5yYAgvemepGQ_mfxGwGDp6WkQmtmTf_gX3ne5v6wghAgGeSD_1746664896253_completion_certificate.pdf",
      skills: [
        "Communication",  
        "Cybersecurity",
        "Data Analysis",
        "Data Presentation",
        "Design Thinking",
        "Problem Solving",
        "Security Awareness Training",
        "Strategy",
        "Technical Security Awareness"
      ],
      icon: <img src={mastercardLogo} alt="Mastercard Logo" style={{width: 70, height: 70, objectFit: 'contain', borderRadius: 6}} />
    },
  ];


  return (
    <section className="certifications-section" id="certifications">
      <div className="certifications-container">
        <h2 className="section-title">Certifications</h2>
        <p className="section-description">
          Professional certifications I've earned throughout my career that validate my expertise
          in various security and technical disciplines.
        </p>

        <div className="certifications-grid">
          {certificationData.map((cert, index) => (
            <CertificationItem key={index} {...cert} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications; 